import * as echarts from 'echarts'
// 衡水市经纬度信息
import geoJson from './131100.mjs'
// // 背景图
// import img from './img.mjs'
window.requestAnimationFrame =
  window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame ||
  window.msRequestAnimationFrame

var width = 22
var regions = []
var angle = 0
// var rotation = 0
// var animationType = true
// 虚线背景配置对象
var dotted = [
  [-100, -30, '110%', 60, '#0CD3DB'],
  [-90, -40, '94%', 35, '#0CD3DB'],
  [-10, 100, '110%', 90, '#0CD3DB'],
  [0, 90, '94%', 60, '#0CD3DB'],
  [160, 220, '110%', 50, '#0CD3DB'],
  [170, 210, '94%', 30, '#0CD3DB']
]
// 实现背景配置对象
var line = [
  [-20, 240, 0.92, 18, '#1f4079'],
  [150, 100, 0.7, 10, '#1f4079'],
  [0, 280, 0.6, 8, '#1f4079']
]

export const generateEchartsPie = function (id) {
  var main = document.getElementById(id)
  main.style.height = width + 'vw'
  main.style.width = width + 'vw'
  // animationType = true

  // 基于准备好的dom，初始化echarts实例
  var myChart = echarts.init(document.getElementById(id))
  window.onresize = function() {
    myChart.resize()
  }
  // 引入衡水市经纬度信息
  echarts.registerMap('hengshui', geoJson)

  regions = geoJson.features.map((item, i) => {
    // 各个区显示设置
    const itemStyle = item.properties.name && item.properties.name !== this.$route.query.city ? {
      areaColor: '#184E9D',
      borderColor: '#2A88AC',
      borderWidth: 1
    } : {
        areaColor: '#FBB206',
        borderColor: '#57D0FF',
        borderWidth: 1
      }
    return {
      name: item.properties.name,
      itemStyle
    }
  })

  var option = {
    backgroundColor: 'rgba(0,0,0,0)',
    tooltip: {
      backgroundColor: 'rgba(0,0,0,0)',
      trigger: 'item',
      formatter: function (item) {
        return '自定义tooltip，支持html形式'
      }
    },
    legend: {
      show: false
    },
    geo: {
      name: '衡水市',
      map: 'hengshui', // 自定义扩展图表类型
      roam: false, // 是否开启鼠标缩放和平移漫游
      clickable: false,
      showLegendSymbol: false,
      selectedMode: false,
      label: {
        show: true,
        color: '#fff',
        fontSize: 16
      },
      itemStyle: {
        emphasis: {
          label: {
            color: '#fff'
          },
          areaColor: '#FBB206',
          borderColor: '#57D0FF',
          borderWidth: 1
        }
      },
      zoom: 1.15, // 缩放
      aspectScale: 0.8,
      layoutCenter: ['50%', '50%'],
      regions,
      z: 3
    },
    // graphic: {
    //   elements: [{
    //     type: 'image',
    //     z: 0,
    //     style: {
    //       image: img,
    //       width: width,
    //       height: width
    //     },
    //     origin: [width / 2, width / 2],
    //     rotation,
    //     position: [0, 0]
    //   }]
    // },
    series: getSeries()
  }

  myChart.setOption(option)
  // window.requestAnimationFrame(animation)

  // 背景动画播放函数
  // function animation () {
  //   // rotation -= 0.01
  //   angle += 0.25
  //   if (angle === 360) angle = 0
  //   myChart.setOption({ series: getSeries() })
  //   if (animationType) window.requestAnimationFrame(animation)
  // }

  function getSeries () {
    var arr = []
    dotted.forEach((a, i) => {
      arr.push({
        name: '虚线段' + (i + 1),
        type: 'gauge',
        splitNumber: a[3],
        radius: a[2],
        startAngle: i % 2 === 0 ? a[0] + angle : a[0] - angle,
        endAngle: i % 2 === 0 ? a[1] + angle : a[1] - angle,
        axisLine: {
          show: false,
          lineStyle: {
            color: [
              [1, 'transparent']
            ]
          }
        },
        axisTick: {
          show: false
        },
        splitLine: {
          show: true,
          length: 2,
          lineStyle: {
            color: a[4],
            width: 2,
            shadowBlur: 10,
            shadowColor: a[4],
            shadowOffsetX: 0,
            shadowOffsetY: 0
          }
        },
        axisLabel: {
          show: false
        },
        detail: {
          show: false
        },
        z: 2
      })
    })
    line.forEach((l, i) => {
      arr.push(
        {
          name: '粗弧线' + (i + 1),
          type: 'custom',
          coordinateSystem: 'none',
          renderItem: function (params, api) {
            let lAngle1 = i % 2 === 0 ? l[0] + angle : l[0] - angle
            let lAngle2 = i % 2 === 0 ? l[1] + angle : l[1] - angle
            return {
              type: 'arc',
              shape: {
                cx: api.getWidth() / 2,
                cy: api.getHeight() / 2,
                r: Math.min(api.getWidth(), api.getHeight()) / 2 * l[2],
                startAngle: lAngle1 * Math.PI / 180,
                endAngle: lAngle2 * Math.PI / 180
              },
              style: {
                stroke: l[4],
                fill: 'transparent',
                lineWidth: l[3]
              },
              silent: true
            }
          },
          data: [0],
          z: 1
        },
        {
          name: '粗弧线' + (i + 1) + '端点1',
          type: 'custom',
          coordinateSystem: 'none',
          renderItem: function (params, api) {
            let lAngle1 = i % 2 === 0 ? l[0] + angle : l[0] - angle
            let x0 = api.getWidth() / 2
            let y0 = api.getHeight() / 2
            let r = Math.min(api.getWidth(), api.getHeight()) / 2 * l[2]
            let point = getCirlPoint(x0, y0, r, lAngle1)
            return {
              type: 'circle',
              shape: {
                cx: point.x,
                cy: point.y,
                r: l[3] / 2 - 1
              },
              style: {
                stroke: l[4],
                fill: l[4]
              },
              silent: true
            }
          },
          data: [0],
          z: 1
        },
        {
          name: '粗弧线' + (i + 1) + '端点2',
          type: 'custom',
          coordinateSystem: 'none',
          renderItem: function (params, api) {
            let lAngle2 = i % 2 === 0 ? l[1] + angle : l[1] - angle
            let x0 = api.getWidth() / 2
            let y0 = api.getHeight() / 2
            let r = Math.min(api.getWidth(), api.getHeight()) / 2 * l[2]
            let point = getCirlPoint(x0, y0, r, lAngle2)
            return {
              type: 'circle',
              shape: {
                cx: point.x,
                cy: point.y,
                r: l[3] / 2 - 1
              },
              style: {
                stroke: l[4],
                fill: l[4]
              },
              silent: true
            }
          },
          data: [0],
          z: 1
        }
      )
    })
    return arr
  }

  // 获取圆上面某点的坐标(x0,y0表示坐标，r半径，angle角度)
  function getCirlPoint (x0, y0, r, angle) {
    let x1 = x0 + r * Math.cos(angle * Math.PI / 180)
    let y1 = y0 + r * Math.sin(angle * Math.PI / 180)
    return {
      x: x1,
      y: y1
    }
  }

  // 点击不同区地图显示切换
  myChart.on('click', (item) => {
    console.log('点击地图', item.name, item.dataIndex)
    regions.forEach(d => {
      Object.assign(d.itemStyle, {
        areaColor: '#184E9D',
        borderColor: '#2A88AC'
      })
    })
    Object.assign(regions.filter(d => d.name === item.name)[0].itemStyle, {
      areaColor: '#FBB206',
      borderColor: '#57D0FF'
    })
    myChart.setOption({ geo: { regions } })
  })

  // myChart.on('mouseover', function (params) {
  //   animationType = false
  // })

  // myChart.on('mouseout', function (params) {
  //   animationType = true
  //   window.requestAnimationFrame(animation)
  // })

  return myChart
}



// WEBPACK FOOTER //
// ./src/util/echarts/echarts-pie.js